import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../Store'

interface Message {
  text: string
  type: 'input' | 'output'
  time?: string
}

type ChatAiState = {
  messages: Message[]
}

export const formatTime = () => {
  return new Date().toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })
}

const initialState: ChatAiState = {
  messages: [
    {
      text: 'Please use the navigation below or ask me anything about Bluepear',
      type: 'output',
      time: formatTime(),
    },
  ] as Message[],
}

const chatAiSlice = createSlice({
  name: 'chatAi',
  initialState,
  reducers: {
    resetChat: (state: ChatAiState) => {
      state.messages = initialState.messages
    },
    pushMessage: (state: ChatAiState, { payload }: PayloadAction<Message>) => {
      state.messages.push({ ...payload, time: formatTime() })
    },
  },
})

export const { resetChat, pushMessage } = chatAiSlice.actions

export const selectMessages = (state: RootState) => state.root.chatAi.messages

export default chatAiSlice.reducer
